"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _breakpoints = _interopRequireDefault(require("../../utils/breakpoints"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Modal = {
  styles: function styles(theme) {
    return {
      defaultModalBoxStyles: {
        background: theme.colors.themeBase,
        borderColor: "transparent",
        borderRadius: 8,
        padding: theme.spacing.base * 3,
        borderImageSource: "none"
      },
      small: {
        width: 300,
        padding: theme.spacing.base * 2
      },
      medium: {
        width: 560
      },
      defaultCloseButtonStyles: {
        backgroundColor: "transparent",
        "& svg": {
          fill: theme.colors.baseContrast070
        }
      },
      fullScreen: _defineProperty({}, _breakpoints.default.ON_DESKTOP, {
        width: "84vw"
      })
    };
  }
};
var _default = exports.default = Modal;